import { put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';

import * as actions from '../../../state';
import { ssoLoginUser } from '../../../events';

export default function* ssoEnrollSubmit(event) {
  yield put(actions.showLoaderPage());

  const apiHash = yield select((state) => state.configs.apiHash);

  const {
    idtoken, vendor, username, password,
  } = event.payload;

  try {
    const params = {
      username,
      password,
      idtoken,
      vendor,
      apiHash,
    };

    yield nsApi.ssoEnroll(params);
    yield put(actions.loginFormErrorMsg(null));
    yield put(ssoLoginUser(idtoken, vendor, username));
  } catch (err) {
    console.error('ssoEnrollSubmit error', err);
    const errorMsg = err.response.headers.warning
      ? err.response.headers.warning
      : 'Login failed. Please try again.';
    yield put(actions.loginFormErrorMsg(errorMsg));
    yield put(actions.showLoginFormPage());
  }
}
